var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExhaustion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    enableBackground: "new 0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#666565",
    d: "M377.893,198.433c0,27.461-22.263,49.718-49.72,49.718s-49.718-22.256-49.718-49.718 c0-27.457,22.261-49.718,49.718-49.718S377.893,170.976,377.893,198.433z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#666565",
    d: "M178.715,373.551H74.9L20.464,195.197c-1.339-4.389,1.13-9.032,5.522-10.373 c4.394-1.359,9.037,1.135,10.376,5.523l50.843,166.579h91.51c4.591,0,8.312,3.724,8.312,8.312 C187.027,369.828,183.306,373.551,178.715,373.551z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#666565",
    d: "M70.674,476.684c-0.278,0-0.56-0.011-0.844-0.044c-4.567-0.459-7.898-4.534-7.438-9.101l10.39-103.134 c0.463-4.571,4.529-7.97,9.104-7.435c4.566,0.461,7.897,4.534,7.438,9.103l-10.39,103.132 C78.501,473.491,74.89,476.684,70.674,476.684z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#666565",
    d: "M181.475,480.326c-4.183,0-7.782-3.15-8.25-7.403L161.45,366.148c-0.503-4.562,2.788-8.67,7.35-9.173 c4.575-0.475,8.667,2.793,9.17,7.354l11.776,106.774c0.503,4.562-2.786,8.67-7.348,9.173 C182.086,480.31,181.781,480.326,181.475,480.326z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#666565",
    d: "M492.48,268.963H268.065c-4.589,0-8.312-3.724-8.312-8.312c0-4.589,3.723-8.312,8.312-8.312H492.48 c4.589,0,8.312,3.722,8.312,8.312C500.792,265.239,497.069,268.963,492.48,268.963z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#666565",
    d: "M461.312,471.337c-4.588,0-8.312-3.723-8.312-8.312V260.651c0-4.589,3.724-8.312,8.312-8.312 c4.589,0,8.312,3.722,8.312,8.312v202.374C469.623,467.614,465.9,471.337,461.312,471.337z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#666565",
    d: "M327.492,439.644l-53.885-157.206v139.565l11.07,32.311c3.811,11.1,16.472,16.808,28.289,12.754 C324.797,463.021,331.296,450.736,327.492,439.644z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#666565",
    d: "M262.524,409.223c0,9.75-7.909,17.662-17.662,17.662l0,0c-9.754,0-17.662-7.912-17.662-17.662V239.709 c0-9.75,7.908-17.662,17.662-17.662l0,0c9.753,0,17.662,7.911,17.662,17.662V409.223z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#666565",
    d: "M256.982,218.801v-25.91c0,0-38.787-23.69-92.813,17.879c-54.025,41.57-60.259,51.175-60.259,51.175 s-3.453,21.201,0.857,38.749c1.793,7.305,4.933,13.981,10.224,18.229c18.008,14.455,106.667,20.741,106.667,20.741V234.168 c0-9.75,7.908-17.662,17.662-17.662"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#666565",
    d: "M245.208,471.337c-4.591,0-8.312-3.723-8.312-8.312V260.651c0-4.589,3.721-8.312,8.312-8.312 c4.591,0,8.312,3.722,8.312,8.312v202.374C253.52,467.614,249.799,471.337,245.208,471.337z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#666565",
    d: "M221.658,339.665c0,0-201.544,53.594-90.151-102.985"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#666565",
    d: "M145.331,225.489c0,0-88.842,39.275-35.579,111.558"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#666565",
    d: "M210.454,188.032c0,0-88.011,16.537-109.131,74.891"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExhaustion);
export default __webpack_public_path__ + "static/media/exhaustion.7f62f533.svg";
export { ForwardRef as ReactComponent };